<mat-card>
  <pre>{{ data | json }}</pre>
</mat-card>
